/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const authMethodShapeSchema = z.object({
  type: z.string(),
});
